import { render } from "./CreateMomentView.vue?vue&type=template&id=d03c825c&scoped=true"
import script from "./CreateMomentView.vue?vue&type=script&lang=js"
export * from "./CreateMomentView.vue?vue&type=script&lang=js"

import "./CreateMomentView.vue?vue&type=style&index=0&id=d03c825c&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d03c825c"]])

export default __exports__